module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper4",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/a1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('About_us')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('About_us')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', {
    staticClass: "page__content left"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('About_text_01')) + ".\n\n\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page__content right"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('About_text_02')) + ".\n\n\n\t\t\t")])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-230e8aa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 2121
// module chunks = 0